<template>
  <Head title="Pathway - Mapping" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <h1 class="m-2">Pathway Mapping</h1>
          <pathways-mapping 
            :client="client" 
            :destination="destination" 
            :census_connection="census_connection" 
            :source_fields="source_fields"
            :ignore_filter="ignore_filter" 
            :segment="segment"
          ></pathways-mapping>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  destination: Object,
  census_connection: Object,
  source_fields: Array,
  ignore_filter: {
    type: Boolean,
    default: false
  },
  segment: {
    type: Object,
    default: null
  }
});
</script>

